var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongYuedu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.675c2.09-1.605 4.456-1.54 5.335-1.448a.4.4 0 01.352.408v7.341a.46.46 0 01-.435.454c-.938.057-3.225.303-5.252 1.383M7 3.675C4.91 2.07 2.544 2.135 1.665 2.227a.4.4 0 00-.353.408v7.341c0 .242.195.44.436.454.938.057 3.225.303 5.252 1.383V3.675z",
    stroke: "#8D92A1",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_yuedu.67af5f2e.svg";
export { SvgTongyongYuedu as ReactComponent };